module.exports = __webpack_public_path__ + "static/img/015日文1稿.bb134fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/015日文1稿.jpg
// module id = VdUT
// module chunks = 0